import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import Skeleton from "components/Skeleton";
import Stack from "components/Stack";
import Text from "components/Text";

import ChecklistInfoBox from "entities/Checklist/components/ChecklistInfoBox";
import LinkedFieldInfoBox from "entities/Field/components/LinkedFieldInfoBox";

export interface ILinkedFieldRow {
  checklistName: string;
  checklistSubTitle: string;
  url?: string;
  linkedFieldName: string;
  linkedFieldsubTitle: string | string[];
  isOverridden: boolean;
}

export interface IConnections {
  isOverridden: boolean;
  connections: Array<ILinkedFieldRow>;
  showLoader: boolean;
}

const Connections = ({
  isOverridden,
  connections,
  showLoader,
}: IConnections) => {
  return (
    <Box>
      {showLoader ? (
        <Skeleton width="100px" variant="text" />
      ) : (
        <Stack
          spacing={1}
          direction="row"
          alignItems="center"
          marginTop={theme.spacing(2)}
        >
          <Text variant="text2" color={colors.gray80} fontWeight={500}>
            {connections.length} connections
          </Text>
        </Stack>
      )}
      <Stack
        direction="row"
        maxWidth="100%"
        gap={2}
        marginTop={theme.spacing(1)}
        marginBottom={theme.spacing(2)}
      >
        <Text
          variant="label"
          color={colors.gray80}
          fontWeight={500}
          flex={1}
          sx={{ opacity: 0.5 }}
        >
          Location
        </Text>
        <Text
          variant="label"
          color={colors.gray80}
          fontWeight={500}
          flex={1}
          sx={{ opacity: 0.5, paddingLeft: 2 }}
        >
          Field
        </Text>
      </Stack>
      <Stack spacing={2} marginTop={1.5}>
        {showLoader && (
          <Stack direction="row" spacing={2} justifyContent="space-between">
            <Skeleton width="100%" height="80px" />
            <Skeleton width="100%" height="80px" />
          </Stack>
        )}
        {!showLoader &&
          connections.map((linkedField, index) => (
            <Stack direction="row" key={index} maxWidth="100%">
              <Stack sx={{ maxWidth: "50%", width: "100%" }}>
                <ChecklistInfoBox
                  title={linkedField.checklistName}
                  subTitle={linkedField.checklistSubTitle}
                  url={linkedField.url}
                  disabled={isOverridden || linkedField.isOverridden}
                />
              </Stack>
              <Stack
                sx={{
                  width: "100%",
                  maxWidth: "50%",
                  paddingLeft: 2,
                }}
              >
                <LinkedFieldInfoBox
                  title={linkedField.linkedFieldName}
                  subTitle={linkedField.linkedFieldsubTitle}
                  showConnectionsDisabledIcon={linkedField.isOverridden}
                />
              </Stack>
            </Stack>
          ))}
      </Stack>
    </Box>
  );
};

export default Connections;
